module.exports = __webpack_public_path__ + "assets/img/Type E (20).6e8cbeb2.jpg";